module.exports = __webpack_public_path__ + "static/media/EngB.a2e20af8.webp";